import "backboneAjaxQAdapter";

import Handlebars from 'handlebars';
import Template from 'text-loader!../../../../templates/analytics/venues/queues/queue_pie_chart.template.html';


import colors from '../../../../../libs/assets/colors.js';
import i18n  from "l10n";

export default Backbone.View.extend({
    tagName: 'div',
    className: 'col-lg-3',
	template: Handlebars.compile(Template),
	data: null,
    initialize: function (options) {
        var self = this;

        this.data = options ? options.data : null;

	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.data.queue, {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        this.loadQueueCharts();

        return this;
	},
	events:{

    },
    loadQueueCharts: function() {
        var chart = this.$el.find("#donut_chart");

        var servedTickets = this.data.queuestatistic.servedCount;
        var pendingTickets = this.data.queuestatistic.pendingCount;
        var notUsedTickets = this.data.queuestatistic.notUsedCount;
        var servingTickets = this.data.queuestatistic.servingCount;

        var totalTickets = servedTickets + notUsedTickets; // +pendingTickets +  + servingTickets;

        var data = [servedTickets, notUsedTickets];

        var colours = [colors.green, colors.mustardYellow, colors.blue];
        var labels = [i18n.t("analytics.served"), i18n.t("analytics.tickets.notUsed_plural")];
        var percentageValues = [0.50, 0.50]; //initial values

        var maxValue = data[0];

        for(var j=1; j<data.length; j++) {
            if(maxValue < data[j])
                maxValue = data[j];
        }

        if(maxValue > 0 && totalTickets > 0) {
            for(var j=0; j<data.length; j++) {
                if(data[j] <= 0)
                    percentageValues[j] = 0;
                else
                    percentageValues[j] = data[j]/totalTickets;
            }
        }

        this.createDonutCharts(chart, data, colours, labels, percentageValues);

        var perCentServed = totalTickets > 0 ? ((servedTickets / totalTickets) * 100) : 0;
        perCentServed = perCentServed.toFixed(0);

        this.$el.find("#perCentServed").html(perCentServed + "%");
        this.$el.find("#perCentServed").css("color", colours[0]);

    },
    createDonutCharts: function(chart, data, colours, labels, percentageValues) {
        var self = this;

        var myChart = new Chart( chart[0], {
            type: 'doughnut',
            data: {
              labels: labels,
              datasets: [
                {
                  backgroundColor: colours,
                  data: percentageValues
                }
              ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutoutPercentage: 60,
                radius: 50,
                autoMargins: false,
                autoResize: false,
                legend: {
                    display: false,
                    align: "left",
                    //divId: legendDivId,
                    position: "bottom",
                    forceWidth: false,
                    equalWidths: true,
                    valueWidth: "250px",
                    labelWidth: "250px",
                    switchable: true
                },
                tooltips: {
                    enabled: false
                }
            }
        });

        myChart.customLegend = chart.parent().find(".q-statistic-legend");

        for(var i=0; i<data.length; i++) {
            var color = colours[i];
            var value = data[i];
            var label = labels[i];

            myChart.customLegend.append('<div class="legend-item" id="legend-item-' + i + '" style="background-color: #fff; clear: both; float: left;">' +
                                            '<div class="legend-marker" style="background: '+ color + '; width: 12px; height: 12px; display: inline-block; margin-right: 0.5rem;"></div>' +
                                            '<div class="legend-value" style="display: inline-block;">' +
                                                '<span style="color: #7e7e7e">' + label + ':</span> <b style="color: ' + color + '";>' + value  + '</b>' +
                                            '</div>' +
                                      '</div>');
        }
    }
});


